module.exports = __webpack_public_path__ + "img/a215_power_on_camera.5cd71ba7.png";